import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export default function BackButton() {
	const navigate = useNavigate();

	return (
		<div
			className="
						bg-bg 
						text-main 
						h-6 sm:h-9 aspect-square 
						mr-5 
						sm:text-xl
						flex items-center justify-center 
						rounded-md 
						cursor-pointer
						hover:opacity-50
						duration-150 ease-in-out
						"
			onClick={() => navigate(-1)}
		>
			<BiArrowBack />
		</div>
	);
}
